export function addDnDHandlers(elem) {
    if (window.navigator.userAgent.indexOf("Edge")) {
        return;
    }
    customDragImage.call(elem, {
        offsetX: 50,
        offsetY: 50,
        createDragImage: function (elem) {
            var nodeElem = elem.cloneNode(true);
            nodeElem.className = "track-dragging";
            return nodeElem;
        }
    });
    elem.addEventListener("dragstart", function (e) {
        e.dataTransfer.setData('Text', this.id);
    });
}
function customDragImage(options) {
    var offsetX = options.offsetX || 0, offsetY = options.offsetY || 0;
    var createDragImage = function ($node, x, y) {
        var dragNode = options.createDragImage($node);
        dragNode.style.top = Math.max(0, y - offsetY) + "px";
        dragNode.style.left = Math.max(0, x - offsetX) + "px";
        dragNode.style.position = "absolute";
        dragNode.style.pointerEvents = "none";
        document.body.appendChild(dragNode);
        setImmediate(function () {
            document.body.removeChild(dragNode);
        });
        return dragNode;
    };
    if (typeof document.createElement("span").dragDrop === "function") {
        this.addEventListener("mousedown", function (e) {
            var DnDNode = createDragImage(this, e.pageX, e.pageY);
            DnDNode.dragDrop();
        });
    }
    this.addEventListener("dragstart", function (e) {
        var dt = e.dataTransfer;
        if (typeof dt.setDragImage === "function") {
            var node = createDragImage(this, e.pageX, e.pageY);
            dt.setDragImage(node, offsetX, offsetY);
        }
    });
    return this;
}
//# sourceMappingURL=ListViewDragHelper.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/components/ListViewDragHelper.js
// module id = 436
// module chunks = 0